'use client';

import React from 'react';
import * as S from './styles';
import { Card } from '@/components/atoms/Card';
import Avatar from '@/components/atoms/Avatar';
import Text from '@/components/atoms/Text';
import Badge from '@/components/atoms/Badge';
import { ProdutoHomeProps } from '../..';

export default function ProdutoHomeMobile(props: ProdutoHomeProps) {
  const {
    nome,
    imagem,
    imagemThumb,
    slug,
    etiqueta,
    assinatura,
    style = {},
  } = props;
  return (
    <Card
      $size={1}
      $insetContent={false}
      $variant="ghost"
      $interactive={true}
      onClick={() => {
        if (slug === 'xbox-game-pass-ultimate') {
          window.location.href = 'https://xbox.chippu.com.br/';
        } else {
          window.location.href = `/${assinatura ? 'assinatura' : 'produto'}/${slug}`;
        }
      }}
    >
      <S.Container style={style}>
        <Avatar
          $size={4}
          $shape="square"
          $variant="solid"
          $color="accent"
          $image={imagemThumb ?? imagem}
          $imageProps={{
            unoptimized: true,
          }}
        />
        <S.ProdutoInfo>
          <S.ProdutoDescricao>
            <Text
              $size={4}
              $color="neutral"
              $weight="bold"
              $align="left"
              $highContrast={true}
              $text={nome}
            />
            {etiqueta ? (
              <Badge
                $size={1}
                $rounded={false}
                $variant="solid"
                $color={etiqueta.corFundo}
                $highContrast={false}
                $text={etiqueta.descricao}
                $textColor={etiqueta.corTexto}
              />
            ) : null}
          </S.ProdutoDescricao>
        </S.ProdutoInfo>
      </S.Container>
    </Card>
  );
}
